import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Helpers from '@rogues/shared/mixins/helpers';
import Props from './props';

@Component({})

/**
 * @name Card
 */
export default class Card extends Mixins(Props, Helpers, HybridMixin) {}
